import crossref_logo from "../assets/images/Powered_by_CrossRef.png";
import protico_logo from "../assets/images/porticoLogo.png";
import clockss_logo from "../assets/images/clockssLogo.png";
import orcid_logo from "../assets/images/orcidLogo.png";
import scholexplorer_logo from "../assets/images/scholix.jpg";
import datacite_logo from "../assets/images/DataCite_logo.png";
import getfulltext_logo from "../assets/images/GetFTR_Logo_Full.png";
import ror_logo from "../assets/images/ROR_logo.png";

import "./ImageContainer.scss";

function ImageContainer() {
  return (
    <div className="image-container">
      <div className="image-container_item d-flex flex-wrap align-items-center justify-content-start justify-content-lg-between gap-3">
        <a href="https://www.crossref.org/services/funder-registry/" target="_blank">
          <img
            src={crossref_logo}
            alt="Crossref"
            className="img-fluid logo-img"
          />
        </a>
        <a href="https://www.portico.org/" target="_blank">
          <img
            src={protico_logo}
            alt="Portico"
            className="img-fluid logo-img"
          />
        </a>
        <a href="https://clockss.org/" target="_blank">
          <img
            src={clockss_logo}
            alt="CLOCKSS"
            className="img-fluid logo-img"
          />
        </a>
        <a href="https://orcid.org/" target="_blank">
          <img src={orcid_logo} alt="ORCID" className="img-fluid logo-img" />
        </a>
        <a href="https://scholexplorer.openaire.eu/" target="_blank">
          <img
            src={scholexplorer_logo}
            alt="ScholExplorer"
            className="img-fluid logo-img"
          />
        </a>
        <a href="https://datacite.org/" target="_blank">
          <img
            src={datacite_logo}
            alt="DataCite"
            className="img-fluid logo-img"
          />
        </a>
        <a href="https://www.getfulltextresearch.com/" target="_blank">
          <img
            src={getfulltext_logo}
            alt="Get Full Text Research"
            className="img-fluid logo-img"
          />
        </a>
        <a href="https://ror.org/" target="_blank">
          <img src={ror_logo} alt="ROR" className="img-fluid logo-img" />
        </a>
      </div>
    </div>
  );
}

export default ImageContainer;
